import * as Yup from "yup";
import { KeyValueMap } from "../../../../../../../../redux/slices/appState/models";

export const addCoachAssignmentFunSchema = (
  commonValidationMessages: KeyValueMap,
  isMandatory: boolean,
) =>
  Yup.object().shape({
    function: Yup.string().required(commonValidationMessages.requiredValidation),
    coach: isMandatory
      ? Yup.string().required(commonValidationMessages.requiredValidation)
      : Yup.string(),
  });
